import { clearPersistedTurns } from './agent-reducer';
import { clearCoachDrafts } from './coach-draft';
import type { CoachScrollSnapshot } from './coach-scroll';
import { clearCoachLinkedContexts } from './coach-linked-context';

const SCROLL_PREFIX = 'coach.thread.scroll.v2:';
const LEGACY_SCROLL_PREFIX = 'coach.thread.scroll.v1:';
const INSIGHT_PREFIX = 'coach-insight-';
const persistenceGenerations = new Map<string, number>();
const memoryScrollSnapshots = new Map<string, CoachScrollSnapshot>();

function userKey(userId?: number): string {
  return String(userId ?? 'anonymous');
}

export function coachClientStateGeneration(userId?: number): number {
  return persistenceGenerations.get(userKey(userId)) ?? 0;
}

export function isCoachClientStateGenerationCurrent(
  userId: number | undefined,
  generation: number,
): boolean {
  return coachClientStateGeneration(userId) === generation;
}

export function coachScrollKey(userId?: number, threadId?: string): string {
  return `${SCROLL_PREFIX}${userKey(userId)}:${threadId ?? 'current'}`;
}

export function rememberCoachScrollSnapshot(
  key: string,
  snapshot: CoachScrollSnapshot,
): void {
  memoryScrollSnapshots.set(key, snapshot);
}

export function loadCoachScrollSnapshot(key: string): CoachScrollSnapshot | undefined {
  return memoryScrollSnapshots.get(key);
}

export function clearCoachClientState(userId?: number): void {
  const user = userKey(userId);
  persistenceGenerations.set(user, coachClientStateGeneration(userId) + 1);
  clearPersistedTurns(userId);
  clearCoachDrafts(userId);
  clearCoachLinkedContexts(userId);

  const scrollPrefix = `${SCROLL_PREFIX}${user}:`;
  const legacyScrollKey = `${LEGACY_SCROLL_PREFIX}${user}`;
  const insightPrefix = `${INSIGHT_PREFIX}${user}-`;
  for (const key of memoryScrollSnapshots.keys()) {
    if (key.startsWith(scrollPrefix) || key === legacyScrollKey) {
      memoryScrollSnapshots.delete(key);
    }
  }
  try {
    for (let index = sessionStorage.length - 1; index >= 0; index -= 1) {
      const key = sessionStorage.key(index);
      if (
        key
        && (
          key.startsWith(scrollPrefix)
          || key === legacyScrollKey
          || key.startsWith(insightPrefix)
        )
      ) {
        sessionStorage.removeItem(key);
      }
    }
  } catch {
    return;
  }
}
